import { CFormCheck, CNav, CNavItem, CNavLink } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  onTemplateValueSet,
  setSelectedSections,
  setSelectedTemplate,
  setTurnDragonOff,
} from 'src/redux/progressNote/progressNoteSlice'
import { chartArrayGenerater, mergeTwoTemplate } from 'src/helper/formater'
import { removeThisSnippets, saveMIPSData } from 'src/helper/backendHelper'
import { toast } from 'react-toastify'
import { TAB_OPTIONS } from '../../../ProgressNote/progressNoteConstants'
import DynamicSectionFilter from '../../../ProgressNote/DynamicSectionFilter'
import DynamicTemplates from '../../../ProgressNote/DynamicTemplates'
import SnippetSection from '../../../ProgressNote/SnippetSection'
import RecentNoteSection from '../../../ProgressNote/RecentNoteSection'
import { getSnips } from './panelNoteHelpers'
import {
  setEncounterField,
  setPanelChartHelper,
} from '../../../../../redux/sidePanel/sidePanelSlice'
import { debouncer } from '../sharedPanelComponents/sharedAIfunctions'
import { saveEncounterField, updatePanelMips } from '../../../../../redux/sidePanel/sidePanelThunk'

export function PanelNoteSections() {
  const dispatch = useDispatch()

  const panelEncounterId = useSelector((state) => state.sidePanel.panelEncounter?._id)
  const snippetList = useSelector((state) => state.sidePanel.panelChartHelpers?.snippets)
  const currentTab =
    useSelector((state) => state.sidePanel.panelChartHelpers?.noteTab) || TAB_OPTIONS.SECTION
  const isTyping = useSelector((state) => state.sidePanel.panelChartHelpers?.isTyping) ?? true

  // note state selectors
  const visitDetails = useSelector((state) => state.progressNote.visitDetails)
  const selectedTemplate = useSelector((state) => state.progressNote?.selectedTemplate)
  const templateData = useSelector((state) => state.progressNote?.selectedTemplate?.data)
  const selectedSections = useSelector((state) => state.progressNote?.selectedSections)
  const activeSection = useSelector((state) => state.progressNote.activeSection)

  const [removedSection, setRemovedSection] = useState([])

  useEffect(() => {
    if (panelEncounterId) {
      getSnips((snips) => dispatch(setPanelChartHelper({ field: 'snippets', value: snips })))
    }
  }, [dispatch, panelEncounterId])

  const setCurrentTab = (newTab) => {
    dispatch(setPanelChartHelper({ field: 'noteTab', value: newTab }))
  }

  const setIsTyping = (typeState) => {
    dispatch(setPanelChartHelper({ field: 'isTyping', value: typeState }))
  }

  //todo i think this works
  useEffect(() => {
    let isMounted = true
    async function update(sec) {
      let txtValue = chartArrayGenerater(sec)
      if (isMounted) {
        await dispatch(onTemplateValueSet(txtValue))
      }
    }

    if (!isTyping) {
      if (currentTab === TAB_OPTIONS.TEMPLATE) {
        let currentSection = templateData?.find((sec) => {
          if (sec?.title === activeSection?.title && !sec?.ignoreTemplateTab) {
            if (sec?.sections?.length > 0) {
              if (
                !(sec?.title === 'Diagnosis (ICD10)' || sec?.title === 'E&M and procedure codes')
              ) {
                return true
              }
            }
          }
          return false
        })
        if (currentSection) {
          update(currentSection)
        }
      }
    }

    return () => {
      isMounted = false
    }
  }, [dispatch, templateData, activeSection, isTyping, currentTab])

  const addSelectedSection = (section) => {
    let isHaveSection = selectedSections.find((sSection) => sSection?.title === section?.title)

    if (!isHaveSection) {
      let inRemovedSection = removedSection?.find((item) => item?.title === section?.title)

      if (inRemovedSection) {
        let newRemovedSections = removedSection?.filter((item) => item?.title !== section?.title)
        setRemovedSection(newRemovedSections)
        dispatch(setSelectedSections([...selectedSections, { ...inRemovedSection, skip: false }]))
      } else {
        dispatch(setSelectedSections([...selectedSections, { ...section, skip: false }]))
      }
      if (section.title === 'Care Coordination') {
        updateCareCoord(true)
      }
      dispatch(setTurnDragonOff(true))
    }
  }

  const removeSelectedSection = (section) => {
    let thisRemovedSection = selectedSections.find((item) => item?.title === section?.title)

    if (thisRemovedSection) {
      let selectedSection = selectedSections.filter((item) => item?.title !== section?.title)

      setRemovedSection([...removedSection, { ...thisRemovedSection, skip: true }])
      dispatch(setSelectedSections(selectedSection))
      if (section.title === 'Care Coordination') {
        updateCareCoord(false)
      }
    }
  }

  const selectAllSection = (e) => {
    let joinedList = mergeTwoTemplate(templateData, selectedSections)

    if (e.currentTarget.checked) {
      let joinedListWithRemoved = mergeTwoTemplate(joinedList, removedSection)
      dispatch(setTurnDragonOff(true))
      dispatch(
        setSelectedSections(
          joinedListWithRemoved.map((newSection) => ({ ...newSection, skip: false })),
        ),
      )
    } else {
      let removableSections = []
      let mandatorySections = []
      joinedList.forEach((section) => {
        if (!section.optional) {
          mandatorySections.push({ ...section, skip: false })
        } else {
          removableSections.push({ ...section, skip: true })
        }
      })
      dispatch(setSelectedSections(mandatorySections))
      setRemovedSection(removableSections)
    }
  }

  const onDeleteSnippet = (id) => {
    removeThisSnippets(id).then((res) => {
      if (res?.status === 'success') {
        toast.success('Snippet removed...')
        getSnips((snips) => dispatch(setPanelChartHelper({ field: 'snippets', value: snips })))
      }
    })
  }

  // what does this do?
  const onTemplateFill = (data, sectionTitle) => {
    let tempList = [...selectedSections]

    const index = tempList.findIndex((item) => item.title === sectionTitle)

    let valueList = tempList[index]?.values ? [...tempList[index]?.values, data] : [data]

    tempList[index] = { ...tempList[index], values: valueList }

    dispatch(setSelectedSections(tempList))
  }

  const updateCareCoord = async (val) => {
    await dispatch(
      setEncounterField({
        field: 'care_coordination',
        value: val,
      }),
    )
    debouncer(() => dispatch(saveEncounterField({})))
  }

  const toggleCareCoord = (oldSection, newSection) => {
    if (oldSection && newSection) {
      const prevVal = oldSection?.sections?.[0]?.options?.[0]?.value
      const newVal = newSection?.sections?.[0]?.options?.[0]?.value
      if (prevVal !== newVal) {
        updateCareCoord(newVal)
      }
    }
  }

  const onDataChange = async (data) => {
    dispatch(setSelectedTemplate({ ...selectedTemplate, data }))
    toggleCareCoord(
      selectedTemplate?.data?.find((sec) => sec.title === 'Care Coordination'),
      data?.find((sec) => sec.title === 'Care Coordination'),
    )
    if (activeSection?.title === 'MIPS') {
      let mips = data
        ?.find((item) => item?.title === 'MIPS')
        ?.sections?.map((mips) => ({
          measureKey: mips?.measureKey,
          value: mips?.value,
          option_data: mips?.options?.find((item) => item?.label === mips?.value),
        }))
        ?.filter((item) => item?.value)

      await saveMIPSData(panelEncounterId, mips)
      dispatch(updatePanelMips())
    }
  }

  return (
    <div>
      <div className="filter-holder">
        <div className="filter-header sideNoteHeaders">
          <CNav variant="pills" layout="fill">
            <CNavItem>
              <CNavLink
                active={currentTab === TAB_OPTIONS.SECTION}
                onClick={() => setCurrentTab(TAB_OPTIONS.SECTION)}
              >
                Sections
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                active={currentTab === TAB_OPTIONS.TEMPLATE}
                onClick={() => setCurrentTab(TAB_OPTIONS.TEMPLATE)}
              >
                Template(s)
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                active={currentTab === TAB_OPTIONS.SNIPPET}
                onClick={() => {
                  setCurrentTab(TAB_OPTIONS.SNIPPET)
                }}
              >
                Snippets
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                active={currentTab === TAB_OPTIONS.RECENTNOTES}
                onClick={() => {
                  setCurrentTab(TAB_OPTIONS.RECENTNOTES)
                }}
              >
                Recent Notes
              </CNavLink>
            </CNavItem>
          </CNav>
        </div>
        <div className="filter-tab">
          <div className="tab-body">
            {currentTab === TAB_OPTIONS.SECTION && (
              <>
                <div className="all-select-check-box">
                  <CFormCheck
                    id={`select-all`}
                    label={`Select all`}
                    onChange={selectAllSection}
                    checked={selectedSections?.length === templateData?.length}
                  />
                </div>
                <div className="filter-holder">
                  <>
                    {templateData?.map((section, index) => {
                      let isChecked = selectedSections.find(
                        (item) => item?.title === section?.title,
                      )

                      return (
                        section?.title !== 'Diagnosis (ICD10)' &&
                        section?.title !== 'E&M and procedure codes' && (
                          <DynamicSectionFilter
                            key={'DynamicSectionFilter' + index}
                            section={section}
                            isChecked={Boolean(isChecked)}
                            addSelectedSection={addSelectedSection}
                            removeSelectedSection={removeSelectedSection}
                          />
                        )
                      )
                    })}
                  </>
                </div>
              </>
            )}
            {currentTab === TAB_OPTIONS.TEMPLATE && (
              <>
                {activeSection && (
                  <DynamicTemplates
                    onTemplateFill={onTemplateFill}
                    onDataChange={onDataChange}
                    section={templateData?.find(
                      (section) => section?.title === activeSection?.title,
                    )}
                    setIsTyping={setIsTyping}
                    // patient details are stuck inside the visit
                    patient={visitDetails}
                  />
                )}
              </>
            )}
            {currentTab === TAB_OPTIONS.SNIPPET && (
              <div className="filter-holder snippet-section">
                <SnippetSection
                  snippetList={snippetList || []}
                  setSnippetList={(snips) =>
                    dispatch(setPanelChartHelper({ field: 'snippets', value: snips }))
                  }
                  onDeleteSnippet={onDeleteSnippet}
                  setIsTyping={setIsTyping}
                  setIsDraftSaved={() => {}}
                  section={templateData?.find((section) => section?.title === activeSection?.title)}
                  getSnips={(sortFunc) => {
                    getSnips(
                      (snips) => dispatch(setPanelChartHelper({ field: 'snippets', value: snips })),
                      sortFunc,
                    )
                  }}
                />
              </div>
            )}

            {currentTab === TAB_OPTIONS.RECENTNOTES && (
              <div className="filter-holder">
                <RecentNoteSection />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
